// components/config/socials.ts
import { 
  IconTelegram, 
  IconDiscord, 
  IconYouTube, 
  IconX, 
  IconTikTok, 
  IconGithub 
} from '@/components/SocialIcons';

export const getSocials = (locale: string) => {
  const isRu = locale === 'ru';

  return [
    {
      id: 'discord',
      label: 'Discord',
      href: 'https://dsc.gg/rplands',
      icon: IconDiscord,
      showInHero: true,
      showInFooter: true,
      heroIconClass: 'w-[19px] h-[20px]',
      footerIconClass: 'w-5 h-5',
      footerHover: 'hover:bg-[#5865F2] hover:border-[#5865F2] hover:text-white hover:shadow-[0_0_16px_rgba(88,101,242,0.6)]'
    },
    {
      id: 'telegram',
      label: 'Telegram',
      href: 'https://t.me/rplands',
      icon: IconTelegram,
      showInHero: isRu,     
      showInFooter: isRu,   
      heroIconClass: 'w-[14px] h-[14px] -ml-[1px] mt-[1px]',
      footerIconClass: 'w-5 h-5 pr-0.5',
      footerHover: 'hover:bg-[#229ED9] hover:border-[#229ED9] hover:text-white hover:shadow-[0_0_16px_rgba(34,158,217,0.6)]'
    },
    {
      id: 'x',
      label: 'X',
      href: 'https://x.com/rp_lands',
      icon: IconX,
      showInHero: !isRu,    
      showInFooter: !isRu,  
      heroIconClass: 'w-[14px] h-[14px]',
      footerIconClass: 'w-4 h-4',
      footerHover: 'hover:bg-white hover:border-white hover:text-black hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]'
    },
    {
      id: 'tiktok',
      label: 'TikTok',
      href: isRu ? 'https://tiktok.com/@rp_lands' : 'https://tiktok.com/@rplands_en',
      icon: IconTikTok,
      showInHero: true,
      showInFooter: true,
      heroIconClass: 'w-[14px] h-[14px]',
      footerIconClass: 'w-[19px] h-[19px]',
      footerHover: 'hover:bg-[#000000] hover:border-[#FE2C55] hover:text-white hover:shadow-[0_0_16px_rgba(254,44,85,0.6)]'
    },
    {
      id: 'youtube',
      label: 'YouTube',
      href: isRu ? 'https://youtube.com/@rplands' : 'https://youtube.com/@rplands_en',
      icon: IconYouTube,
      showInHero: true,
      showInFooter: true,
      heroIconClass: 'w-[14px] h-[14px]',
      footerIconClass: 'w-5 h-5',
      footerHover: 'hover:bg-[#FF0000] hover:border-[#FF0000] hover:text-white hover:shadow-[0_0_16px_rgba(255,0,0,0.6)]'
    },
    {
      id: 'github',
      label: 'GitHub',
      href: 'https://github.com/royolands',
      icon: IconGithub,
      showInHero: false, 
      showInFooter: true,
      heroIconClass: '',
      footerIconClass: 'w-5 h-5',
      footerHover: 'hover:bg-white hover:border-white hover:text-black hover:shadow-[0_0_16px_rgba(255,255,255,0.4)]'
    }
  ];
};